import { ITypedReduxAction } from '../../../types/redux/actionType';
import { IAuthorArticles } from '../../../types/authorArticles';

export enum EGetAuthorArticlesActionType {
  Loading = 'authorArticles/getAuthorArticles/loading',
  Succeed = 'authorArticles/getAuthorArticles/succeed',
  AppendSucceed = 'authorArticles/getAuthorArticles/appendSucceed',
  Failed = 'authorArticles/getAuthorArticles/failed',
}

export type TGetAuthorArticlesLoading = ITypedReduxAction<EGetAuthorArticlesActionType.Loading>;
export type TGetAuthorArticlesSucceed = ITypedReduxAction<EGetAuthorArticlesActionType.Succeed, IAuthorArticles>;
export type TGetAuthorArticlesAppendSucceed = ITypedReduxAction<
  EGetAuthorArticlesActionType.AppendSucceed,
  IAuthorArticles
>;
export type TGetAuthorArticlesFailed = ITypedReduxAction<EGetAuthorArticlesActionType.Failed>;

export type TGetAuthorArticles =
  | TGetAuthorArticlesLoading
  | TGetAuthorArticlesSucceed
  | TGetAuthorArticlesAppendSucceed
  | TGetAuthorArticlesFailed;
